"use strict";
exports.__esModule = true;
var utils_1 = require("@lglp/utils");
// html common attributes
exports["default"] = utils_1.extract([
    /^aria-.+$/,
    'accesskey',
    'class',
    'contenteditable',
    'contextmenu',
    /^data-.+$/,
    'disabled',
    'dir',
    'draggable',
    'dropzone',
    'hidden',
    'id',
    'lang',
    'loading',
    'role',
    'spellcheck',
    'style',
    'tabIndex',
    'title',
    'translate',
    /^itemProp$/i,
    /^itemScope$/i,
    /^itemType$/i,
]);
//# sourceMappingURL=html.js.map